import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const normComponent: ComponentDef = {
  id: 'norm',
  name: 'Normalization',
  description: 'LayerNorm / RMSNorm / BatchNorm / GroupNorm / InstanceNorm applied to hidden states.',
  category: 'component',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    {
      name: 'variant',
      label: 'Variant',
      type: 'select',
      default: 'layernorm',
      options: [
        { label: 'LayerNorm', value: 'layernorm' },
        { label: 'RMSNorm', value: 'rmsnorm' },
        { label: 'BatchNorm', value: 'batchnorm' },
        { label: 'GroupNorm', value: 'groupnorm' },
        { label: 'InstanceNorm', value: 'instancenorm' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const variant = String(params.variant);

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);

    if (variant === 'groupnorm') {
      // GroupNorm: divide channels into G groups, normalize mean/var within each group
      const numGroups = 32;
      const groupSize = d_model / numGroups;
      g.reshape('groups', 'x', [seq_len, numGroups, groupSize]);
      g.norm('group_normed', 'groups', 'GroupNorm');
      g.reshape('out', 'group_normed', [seq_len, d_model]);
      g.output('out', 'out');

    } else if (variant === 'instancenorm') {
      // InstanceNorm: normalize each channel (feature) independently across spatial dims
      g.reshape('channels', 'x', [seq_len, d_model, 1]);
      g.norm('inst_normed', 'channels', 'InstanceNorm');
      g.reshape('out', 'inst_normed', [seq_len, d_model]);
      g.output('out', 'out');

    } else {
      const label = variant === 'rmsnorm' ? 'RMSNorm' : variant === 'batchnorm' ? 'BatchNorm' : 'LayerNorm';
      g.norm('norm', 'x', label);
      g.output('out', 'norm');
    }

    return g.build();
  }
};
